export const AUTHORS_LIST = {
    authorsNone: 'Авторы отсутствуют',
    searchAuthor: 'Поиск по ФИО',
    searchEditor: 'Редакция',
    allEditors: 'Все редакции',
    searchIsFared: 'Показать уволенных сотрудников',
    createAuthor: 'Добавить автора'
}